import Slugify from '@Utils/Slugify';

const getSubstanceSubPropertyId = (fact, child, substanceIndex) =>
  `accordion-${Slugify(fact.title)}-${Slugify(child.title)}-${substanceIndex}`;

export default getSubstanceSubPropertyId;
